import React, { createContext, useState, useCallback } from 'react';

export const HomepageCacheContext = createContext();

export function HomepageCacheProvider({ children }) {
  const [cachedCmsData, setCachedCmsData] = useState(null);
  const [cachedMediaMap, setCachedMediaMap] = useState({});
  const [cacheTimestamp, setCacheTimestamp] = useState(null);
  const CACHE_DURATION = 1 * 60 * 1000; // 1 minute (instead of 5) for realtime data

  const isCacheValid = useCallback(() => {
    if (!cacheTimestamp) return false;
    return Date.now() - cacheTimestamp < CACHE_DURATION;
  }, [cacheTimestamp]);

  const getCachedData = useCallback(() => {
    if (isCacheValid()) {
      return { cmsData: cachedCmsData, mediaMap: cachedMediaMap };
    }
    return { cmsData: null, mediaMap: {} };
  }, [isCacheValid, cachedCmsData, cachedMediaMap]);

  const setCacheData = useCallback((cmsData, mediaMap) => {
    setCachedCmsData(cmsData);
    setCachedMediaMap(mediaMap);
    setCacheTimestamp(Date.now());
  }, []);

  const clearCache = useCallback(() => {
    setCachedCmsData(null);
    setCachedMediaMap({});
    setCacheTimestamp(null);
  }, []);

  return (
    <HomepageCacheContext.Provider value={{ getCachedData, setCacheData, clearCache, isCacheValid }}>
      {children}
    </HomepageCacheContext.Provider>
  );
}
